<template>
  <md-field
    :class="fieldClass"
  >
    <label :for="id">{{ label }}</label>
    <label :for="id" class="showed" v-if="showAnyway">{{ label }}</label>
    <!-- <div class="abs">{{ values }}</div> -->
    <md-select
      :placeholder="placeholder"
      :disabled="disabled"
      :multiple="multiple"
      :required="required"
      :md-dense="dense"
      :value="value"
      :name="name"
      :id="id"
      :mdClass="callLocation"
      @input="onInput"
      @md-selected="onChange"
    >
      <md-option v-for="(val, i) in values" :value="val" :selected="val === value" :key="i">{{ val }}</md-option>
    </md-select>
    <span v-if="clear && value && value.length"
          class="md-select-clear-selection"
          @click="clearSelection">
      <md-icon class="clear-icon-size">clear</md-icon>
    </span>
    <span class="md-error" v-if="errorMessage">{{ errorMessage }}</span>
  </md-field>
</template>

<script>
  import FieldMixin from './field.mixin'

  export default {
    name: 'select-field',
    mixins: [FieldMixin],
    props: {
      values: { type: Array, default: _ => [] },
      multiple: { type: Boolean, default: false },
      dense: { type: Boolean, default: false },
      clear: { type: Boolean, default: false },
      showAnyway: {type: Boolean, default: false}
    },
    methods: {
      onChange (value) {
        this.$emit('change', value)
      },
      clearSelection () {
        this.$emit('input', '')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .md-select-clear-selection {
    margin: 0;
    padding: 0;
  }
  .clear-icon-size {
    width: 16px;
    min-width: 16px;
    height: 16px;
    font-size: 16px!important;
  }
</style>



// WEBPACK FOOTER //
// src/vue/common/fields/SelectField.vue